<template>
  <vx-card no-shadow>
    <div class="flex flex-wrap justify-between items-center" v-if="showWindow">
      <div class="vx-row mb-4" v-for="(item,index) in fieldsData" :key="index" v-show="index!=='phone2' && index!=='timestamp'">
        <div class="vx-col w-full">
          {{index}}
          <br />
          <vs-input class="inputx inline-block" size="normal" v-model="fieldsData[index]" :readonly="isReadOnly(index)"/>&nbsp;
          <vs-button color="primary" class="inline-block"  size="small" type="gradient" icon="content_copy" @click="copyToClipBoard(index)">Copy</vs-button>
        </div>
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button disabled @click="sendData('update-client')" class="ml-auto mt-2">Save Changes</vs-button>
    </div>
  </vx-card>
</template>

<script>
import axios from "@/axios.js"
export default {
  data() {
    return {
      params:{},
      fieldsData:{},
      init:false,
      popupActive:false,
      editable:['email','Country','state','address','postal','city','phone1','phone2','first_name','last_name']
    }
  },
  computed: {
    showWindow(){
      if(this.$route.path.indexOf('/brokers/')!==-1){
        if(this.init===false){            
          this.setData();
        }
        return true;
      }
      return false;
    },
  },
  methods:{
    copyToClipBoard: function(index){
      let that = this;
      let text = this.fieldsData[index];
      let textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      try {
          if(document.execCommand('copy'))
            that.openAlert('success','','copied to clipboard');
      } catch (err) {
          console.log('Oops, unable to copy');
      }
      document.body.removeChild(textArea);
    },
    isReadOnly: function(index){
        return this.editable.indexOf(index)===-1;
      },
      setData: function(){
        this.init = true;
        const params = new URLSearchParams();
        params.append('uname', this.$route.params.brokerId);
        let that = this;
        axios.post("/api/brokers",params)
        .then((response) => {
          that.fieldsData = response.data 
        })
        .catch((error) => { console.log('error',error) })
      },
      sendData: function(type){
        let that = this;
        const params = new URLSearchParams();
        params.append('type', type);
        switch(type){
          case 'update-client':
            params.append('email', this.$route.params.email);
            params.append('first_name', this.fieldsData.first_name);
            params.append('last_name', this.fieldsData.last_name);
            params.append('phone_code1', this.fieldsData.phone_code1);
            params.append('phone1', this.fieldsData.phone1);
            params.append('address', this.fieldsData.address);
            params.append('city', this.fieldsData.city);
            params.append('state', this.fieldsData.state);
            params.append('Country', this.fieldsData.Country);
            params.append('postal', this.fieldsData.postal);
            break;
        }
        this.$vs.loading();
        axios.post("/api/client",params)
        .then((data) => {
          that.setData(true);
          that.$vs.loading.close();
          that.popupActive = false;
          that.params = {};
          if(data.data[0].out1==='system busy')
            that.openAlert('danger','Failed',data.data[0].out1);
          else
            that.openAlert('success','Success',data.data[0].out1);
         })
        .catch((error) => { that.$vs.loading.close(); that.openAlert('danger','Failed',error[0].out1); })
      },
      openAlert(color,title,text) {
        let colorAlert = color;
        this.$vs.notify({
          title: title,
          text: text,
          color: colorAlert
        })
      },
    }
}
</script>